<template>
  <comfirm-modal :id="'clearListModal'" :title="$t('ui.clearList')" :text="$t('ui.clearListConfirm')" :ico="'bi-trash'"
    :okText="$t('ui.clear')" @on-ok="clearList">
  </comfirm-modal>
</template>

<script>
import toDoListRepository from "../../repositories/toDoListRepository";
import comfirmModal from "../../components/comfirmModal.vue";
import notifications from "../../helpers/notifications";
import repeatingEventHelper from "../../helpers/repeatingEvents.js";

export default {
  name: "clearListModal",
  components: {
    comfirmModal
  },
  methods: {
    clearList: function () {
      const listId = this.$store.getters.listToClearId;
      const list = (this.$store.getters.todoLists[listId] || []).slice();
      // Keep generation markers so refresh does not rematerialize cleared repeating instances
      const reIds = new Set();
      for (const todo of list) {
        if (todo && todo.repeatingEvent) reIds.add(todo.repeatingEvent);
      }
      const cached = this.$store.getters.repeatingEventDateCache[listId] || [];
      for (const reId of cached) {
        if (reId) reIds.add(reId);
      }
      for (const reId of reIds) {
        repeatingEventHelper.markDayHandled(this, listId, reId);
      }
      this.$store.commit("clearTodoList", listId);
      toDoListRepository.update(listId, []);
      notifications.refreshDayNotifications(this, listId);
    }
  }
}
</script>
